import React, { useEffect } from "react";
import { type IconType } from "react-icons/lib";
import Carat from "./Carat";
import { useStore } from "../../main";
interface ToolbarButtonProps {
  id: string;
  active: boolean;
  label?: string;
  icon?: string;
  reactIcon?: IconType;
  iconSize?: "sm" | "md" | "lg";
  onClick?: () => void;
  component?: React.FC<ToolbarButtonProps> | undefined;
  hideLabelOnMobile?: boolean;
  hiddenOnMobile?: boolean;
  hidden?: boolean;
  disabled?: boolean;
  className?: string;
  hideLabelOnTablet?: boolean;

  highlightColor?: string;
  isMobileDropdown?: boolean;
  textColor?: string;
}
const ToolbarButton: React.FC<ToolbarButtonProps> = (
  props: ToolbarButtonProps
) => {
  if (props.hidden) return null;
  const buttonRef = React.createRef<HTMLButtonElement>();
  const [left, setLeft] = React.useState(0);
  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
  const { isTablet, isMobile } = useStore();

  useEffect(() => {
    const setupLeftPosition = () => {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        setLeft(rect.left);
      }
    };
    setupLeftPosition();
    const handleResize = (e) => {
      setScreenWidth(window.innerWidth);
      setupLeftPosition();
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [props.active]);

  return (
    <>
      <button
        ref={buttonRef}
        onClick={props.onClick}
        disabled={props.disabled}
        // style={{
        //   background: props.active
        //     ? "linear-gradient(to bottom,#e7cb95,#c6b187)"
        //     : "linear-gradient(to bottom, #d9af66, #a58752)",
        // }}
        style={{
          background: props.active
            ? props.highlightColor
              ? props.highlightColor
              : "linear-gradient(to bottom,#e7cb95,#c6b187)"
            : "",
          color: props.textColor ? props.textColor : "black",
        }}
        className={`
            ${props.active ? "active" : ""}
            ${props.className ? props.className : ""}
        ${props.hiddenOnMobile ? "sm:hidden xs:hidden md:inline-block" : ""}
        ${
          props.id === "right0" ? "border-l-0.5" : ""
        } font-trebuchet text-[12px] h-full border-black border-r-0.5 px-1 md:px-3 min-w-10 md:w-auto hover:brightness-110 ${
          props.disabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        <span className="flex items-center flex-nowrap">
          {props.icon && (
            <img
              src={props.icon}
              alt={props.label}
              className={`${
                props.iconSize === "sm"
                  ? "h-6 w-6" // mr-1
                  : props.iconSize === "md"
                  ? "h-5 w-5" // mr-2
                  : props.iconSize === "lg"
                  ? "h-7 w-7" // mr-2
                  : "h-5 w-5" // mr-2
              } inline-block m-auto`}
            />
          )}

          {/* {!props.icon && !props.reactIcon && (
            <span className="flex items-center">
              <span className="h-5 w-5 inline-block" />
            </span>)} */}

          {
            <span
              className={`${
                props.hideLabelOnTablet ? " lg:inline-block" : "" //md:hidden
              }`}
            >
              {props.reactIcon ? (
                <>
                  <span className="flex items-center">
                    <props.reactIcon
                      color={props.textColor ? props.textColor : "black"}
                      size={18}
                      className="p-0.5"
                    />
                    {props.isMobileDropdown ||
                      (props.label && (
                        <span className="ml-2 md:hidden">{props.label}</span>
                      ))}
                  </span>
                </>
              ) : (
                <>
                  {props.label && (!props.hideLabelOnTablet || !isTablet) && (
                    <span
                      className={`lg:inline-block ${
                        props.icon ? "ml-2" : "px-1"
                      }`}
                    >
                      {props.label}
                    </span>
                  )}
                </>
              )}
            </span>
          }

          {props.component && (
            <Carat color={props.textColor ? props.textColor : "black"} />
          )}
        </span>
      </button>

      <span
        className={`${
          props.hiddenOnMobile ? "sm:hidden xs:hidden md:inline-block" : ""
        } absolute mt-10`}
        style={{ left: left + "px" }}
      >
        {props.component && <props.component {...props} />}
      </span>
    </>
  );
};
export default ToolbarButton;
